export async function IsiCreate( 
    isiResp,
    isiFecha,
    isiPreg001a,
    isiPreg001b,
    isiPreg001c,
    isiPreg002,
    isiPreg003,
    isiPreg004,
    isiPreg005,
    tratamientoId,
    pacienteId
     ) {
    const formData = {
        title: `us-${pacienteId}-tr-${tratamientoId}-isi-${isiFecha}`,
        slug: `us-${pacienteId}-tr-${tratamientoId}-isi-${isiFecha}`,
        status: "publish",
        tratamiento: tratamientoId,
        paciente: pacienteId,
        meta: {
            isiResp: isiResp,
            isiFecha: isiFecha,
            isiPreg001a: isiPreg001a,
            isiPreg001b: isiPreg001b,
            isiPreg001c: isiPreg001c,
            isiPreg002: isiPreg002,
            isiPreg003: isiPreg003,
            isiPreg004: isiPreg004,
            isiPreg005: isiPreg005
        }
    };

	const authToken = sessionStorage.getItem( 'token' );

        try {
            const response = await fetch('https://app.tavad.com/hce/wp-json/wp/v2/isi', {
                method: 'POST',
                headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${ authToken }`,
                
                },
                body: JSON.stringify(formData),
            } );
            const values = await response.json();
            console.log(values);
            return values;
        } catch (error) {
            console.error(error);
        }

}